import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

export default function SitemapEditor() {
  const [content, setContent] = useState("");
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const response = await ApiRequest("GET", ApiEndpoints.sitemap.view);
        setContent(response?.sitemap?.content || "");
      } catch (error) {
        toast.error(error.response?.data?.message || "Unable to load sitemap.");
      } finally {
        setLoading(false);
      }
    };

    fetchSitemap();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrors([]);

    if (!content.trim()) {
      setErrors(["Sitemap XML is required."]);
      return;
    }

    setSaving(true);
    try {
      const response = await ApiRequest("POST", ApiEndpoints.sitemap.update, { content });
      toast.success(response.message);
    } catch (error) {
      const apiErrors = error.response?.data?.errors || [];
      setErrors(apiErrors.length ? apiErrors : ["Unable to update sitemap."]);
      toast.error(error.response?.data?.message || "Unable to update sitemap.");
    } finally {
      setSaving(false);
    }
  };

  const pagename = {
    name: "Sitemap Management",
    user: "Admin",
    innerpage: "Sitemap Management",
  };

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="add-page-inputs">
                  <div className="label-wrap-add"><label>Sitemap XML<small>*</small></label></div>
                  <textarea
                    name="content"
                    value={content}
                    onChange={(event) => setContent(event.target.value)}
                    className="form-control"
                    rows="24"
                    disabled={loading || saving}
                    placeholder={loading ? "Loading sitemap..." : "Paste sitemap XML here."}
                    style={{ height: "auto", fontFamily: "monospace", whiteSpace: "pre", overflow: "auto" }}
                  />
                </div>
              </div>

              {errors.length > 0 && (
                <div className="col-lg-12">
                  <div className="alert alert-danger">
                    {errors.map((error) => <div key={error}>{error}</div>)}
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <button className="default-btn" type="submit" disabled={loading || saving}>
                  {saving ? "Saving..." : "Save Sitemap"}<span></span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
